import { render } from "./EmptyResult.vue?vue&type=template&id=6a7add50&scoped=true"
import script from "./EmptyResult.vue?vue&type=script&lang=js"
export * from "./EmptyResult.vue?vue&type=script&lang=js"

import "./EmptyResult.vue?vue&type=style&index=0&id=6a7add50&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7add50"]])

export default __exports__